import { Box } from "@mui/material";
import CustomAutoComplete from "@/modules/common/components/input/dropdowns/auto-complete";
import CustomLabel from "@/modules/common/components/input/custom-label";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface SelectInputWithSmallLabelProps {
  label?: string;
  value: string;
  onChange: (event: any) => void;
  options: Array<{ label: string; value: string }>;
  placeholder?: string;
  loading?: boolean;
  [key: string]: any;
}

const SelectInputWithSmallLabel = ({
  label,
  value,
  onChange,
  options,
  placeholder = "Select option",
  handleSearch,
  loading = false,
  ...props
}: SelectInputWithSmallLabelProps) => {
  const customLabelStyle = {
    ...nawyTheme.nawy.typography.english.variants.body.xs.regular,
    color: nawyTheme.nawy.colors.semantic.text.secondary,
  };

  // Convert value to option object for CustomAutoComplete
  const selectedOption =
    options.find((option) => option.value === value) || null;

  const handleChange = (selectedOption: any) => {
    const syntheticEvent = {
      target: {
        value: selectedOption?.value || "",
      },
    };
    onChange(syntheticEvent);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {label && <CustomLabel sx={customLabelStyle}>{label}</CustomLabel>}
      <CustomAutoComplete
        options={options}
        value={selectedOption}
        onChange={handleChange}
        handleSearch={handleSearch}
        placeholder={placeholder}
        loading={loading}
        fullWidth
        {...props}
      />
    </Box>
  );
};

export default SelectInputWithSmallLabel;
